(() => {
	angular.module('main').controller('ProductsController', ProductsController);

	ProductsController.$inject = ['$scope'];

	function ProductsController($scope) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.breadcrumbs = [
				{ link: '/', title: 'Dashboard' },
				{ link: '/settings', title: 'Settings' },
				{ link: null, title: 'Products & Packages' }
			];
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/productsController.js